export const useKftLocalStorage = <T>(key: string, defaultValue: T) => {
  const data = useState(key, () => defaultValue)
  const loaded = ref(false)

  // Function to force load data from localStorage
  const loadFromStorage = () => {
    if (!process.client || loaded.value) return

    let storedData
    try {
      storedData = localStorage.getItem(key)
    } catch (error) {
      console.error('Error accessing local storage', error)
    }
    if (storedData) {
      data.value = JSON.parse(storedData)
    }
    loaded.value = true
  }

  onBeforeMount(() => {
    loadFromStorage()
  })

  watch(
    data,
    () => {
      try {
        localStorage.setItem(key, JSON.stringify(data.value))
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error accessing local storage', error)
      }
    },
    { deep: true }
  )

  return { data, loaded, loadFromStorage }
}
